import { motion } from 'framer-motion';
import { TrendingUp, BarChart3, Zap, Users, Clock, DollarSign } from 'lucide-react';
import '../styles/BusinessOutcomes.css';

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.65, ease: [0.22, 1, 0.36, 1], delay },
});

const outcomes = [
  {
    icon: TrendingUp,
    metric: '45%',
    label: 'Faster Growth',
    description: 'Accelerated digital transformation & market expansion'
  },
  {
    icon: BarChart3,
    metric: '60%',
    label: 'Efficiency Gain',
    description: 'Improved operational efficiency & process automation'
  },
  {
    icon: DollarSign,
    metric: '35%',
    label: 'Cost Reduction',
    description: 'Reduced infrastructure & operational expenses'
  },
  {
    icon: Zap,
    metric: '3x',
    label: 'Faster Delivery',
    description: 'Quicker product releases & deployment cycles'
  },
  {
    icon: Users,
    metric: '99%',
    label: 'Customer Satisfaction',
    description: 'Enhanced engagement & improved experiences'
  },
  {
    icon: Clock,
    metric: '100%',
    label: 'Scalability',
    description: 'Cloud-native & AI adoption readiness'
  },
];

export default function BusinessOutcomes() {
  return (
    <section className="section business-outcomes">
      <div className="container">
        <motion.div className="outcomes__header" {...fadeUp(0)}>
          <div className="section__tag">Business Impact</div>
          <h2 className="section__title">Delivering Measurable Business Impact</h2>
        </motion.div>

        <div className="outcomes__grid">
          {outcomes.map((outcome, idx) => {
            const Icon = outcome.icon;
            return (
              <motion.div
                key={idx}
                className="outcome-item"
                {...fadeUp(idx * 0.06)}
                whileHover={{ y: -8 }}
                transition={{ duration: 0.3 }}
              >
                <div className="outcome-item__icon-wrapper">
                  <Icon size={32} className="outcome-item__icon" />
                </div>
                <div className="outcome-item__metric">{outcome.metric}</div>
                <h3 className="outcome-item__label">{outcome.label}</h3>
                <p className="outcome-item__description">{outcome.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
